import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const Sidebar = () => {
    const { user, hasPermission, hasRole, hasAnyRole, hasAnyPermission } = useUser();
    const location = useLocation();
    const [availableModules, setAvailableModules] = useState([]);

    useEffect(() => {
        const checkModules = async () => {
            const modules = [
                { 
                    path: '/admin/dashboard', 
                    label: 'Управление пользователями', 
                    checkAccess: () => hasAnyPermission("positions", ["view", "create", "edit", "delete"]) || 
                                   hasPermission("users", "create") || 
                                   hasPermission("users", "view") || 
                                   hasPermission("events", "view") || 
                                   hasPermission("logs", "view")
                },
                { path: '/nfc-scanner', label: 'NFC Сканер', module: 'nfc', action: 'scan' },
                { path: '/nfc-management', label: 'Управление NFC', module: 'nfc', action: 'view' },
                { path: '/checkpoints', label: 'Управление КПП', module: 'checkpoints', action: 'view' },
                { path: '/products', label: 'Управление продуктами', module: 'products', action: 'view' },
                { path: '/qr-scanner', label: 'Сканер QR', module: 'qr', action: 'scan' },
                { path: '/qr-list', label: 'Список QR', module: 'qr', action: 'view' },
                { path: '/departments', label: 'Управление отделами', module: 'departments', action: 'view' },
				{ path: '/analytics/hierarchical', label: 'Аналитика посещаемости', module: 'analytics', action: 'view' },
                { 
                    path: '/orders', 
                    label: 'Управление заказами', 
                    checkAccess: () => hasAnyRole(['admin', 'director', 'departmentHead', 'unitChief', 'chief', 'masrter', 'teamLead', 'worker'])
                },
                { 
                    path: '/orders/create', 
                    label: 'Создать заказ', 
                    checkAccess: () => hasRole('director')
                },
                { 
                    path: '/settings', 
                    label: 'Настройки системы', 
                    checkAccess: () => hasAnyRole(['admin', 'director'])
                },
            ];

            if (user?.user?.isSuperUser) {
                setAvailableModules(modules);
                return;
            }

            const available = [];
            for (const module of modules) {
                if (module.module && module.action) {
                    const hasAccess = hasPermission(module.module, module.action);
                    if (hasAccess) {
                        available.push(module);
                    }
                } else if (module.checkAccess) {
                    if (module.checkAccess()) {
                        available.push(module);
                    }
                }
            }
            setAvailableModules(available);
        };
        checkModules();
    }, [hasPermission, hasRole, hasAnyRole, hasAnyPermission, user]);

    return (
        <aside className="flex-none w-64 bg-[#252526] border-r border-[#3E3E42] p-4 overflow-y-auto">
            <h2 className="text-[#CCCCCC] text-lg font-semibold mb-4 text-center tracking-wide uppercase">
                Навигация
            </h2>
            <div className="space-y-4 flex flex-col">
                {availableModules.map(({ path, label }) => (
                    <Link
                        key={path}
                        to={path}
                        className={`w-full bg-[#2D2D30] text-[#CCCCCC] px-4 py-2 rounded text-sm font-medium 
                            border border-[#3E3E42] hover:bg-[#3E3E42] 
                            transition duration-200 ease-in-out transform hover:scale-105 active:scale-95
                            ${location.pathname === path ? 'bg-[#3E3E42]' : ''}`}
                    >
                        {label}
                    </Link>
                ))}
            </div>
        </aside>
    );
};

export default Sidebar; 